module.exports = __webpack_public_path__ + "h5/img/logo2.2f49ed78.png";